import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import './Scoreboard.css';

const Scoreboard = () => {
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(true);

  // Helper function to format team names like "BTECH1" to "1st Year"
  const formatYear = (teamName) => {
    if (!teamName) return '';
    const upperName = teamName.toUpperCase();
    if (upperName === 'BTECH1') return '1st Year';
    if (upperName === 'BTECH2') return '2nd Year';
    if (upperName === 'BTECH3') return '3rd Year';
    if (upperName === 'BTECH4') return '4th Year';
    // Fallback if not BTECH format
    return teamName;
  };

  useEffect(() => {
    const fetchLeaderboard = async () => {
      try {
        const response = await api.get('/results/leaderboard');
        // The backend returns an array of team objects sorted by points
        setLeaderboard(response.data);
      } catch (error) {
        console.error('Error fetching leaderboard:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchLeaderboard();
  }, []);

  return (
    <div className="scoreboard-container">
      <div className="blackboard">
        <div className="chalk-border">
          <h2 className="chalk-title">DHWANI '26 SCOREBOARD</h2>
          
          {loading ? (
            <div className="chalk-loading">Crunching the numbers...</div>
          ) : (
            <div className="chalk-table-container">
              <table className="chalk-table">
                <thead>
                  <tr>
                    <th>Postion</th>
                    <th>Year</th>
                    <th>Points</th>
                  </tr>
                </thead>
                <tbody>
                  {leaderboard.length > 0 ? (
                    leaderboard.map((team, index) => (
                      <tr key={team._id || team.name} className={index === 0 ? 'first-place' : ''}>
                        <td>{index + 1}</td>
                        <td>{formatYear(team.name)}</td>
                        <td className="points-cell">{team.points}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="no-data">No results published yet.</td>
                    </tr>
                  )}
                </tbody>
              </table>
              
              {/* Current leader announcement removed as per request */}
            </div>
          )}
          
          <div className="eraser-mark eraser-1"></div>
          <div className="eraser-mark eraser-2"></div>
        </div>
      </div>
    </div>
  );
};

export default Scoreboard;
